import { render } from "./Face2FaceRequired.vue?vue&type=template&id=41e5a7d9"
import script from "./Face2FaceRequired.vue?vue&type=script&lang=js"
export * from "./Face2FaceRequired.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__